import APIURLConstants from "../common/ApiURLConstants";
import APIHelper from "../common/ApiHelper";
import { authHeader } from "../helper";

export const playerCareerStatsService = {
  saveStats,
};

async function saveStats(obj) {
  const response = await APIHelper.post(
    `${APIURLConstants.SAVE_PLAYER_CAREER_STATS_STATS}`,
    obj,
    authHeader()
  );
  return response;
}
